import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://vegafoodies.herokuapp.com'
})

export default instance;